import { render, staticRenderFns } from "./RegisterFromTokenComponent.vue?vue&type=template&id=548646d5"
import script from "./RegisterFromTokenComponent.vue?vue&type=script&lang=js"
export * from "./RegisterFromTokenComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports